export const facetName = (name) => {
  const storage = {
    // Image Retrieved Status
    Retrieved: 'Retrieved',
    UnexpectedError: 'Unexpected Error',
    RequestToRetrieve: 'Request to Retrieve',
    TargetNotFound: 'Target Not Found',
    TargetFromShortcutNotFound: 'Shortcut Target Not Found',
    //
    // Batch Link Status
    NotLinked: 'Not Linked',
    PartialLink: 'Partially Linked',
    SingleLink: 'Single Link',
    MultiLink: 'Multiple Links',
    //
    // Image Type
    Other: 'Document',
    //
  };
  return storage[name] || name;
};
